import { useContext, Dispatch } from 'react';
import { LoginState, LoginAction } from '../types';
import { AuthContext } from '../contexts';

export function useAuthContext(): { state:LoginState, dispatch: Dispatch<LoginAction>} {
  const {state, dispatch} = useContext(AuthContext);
  return {state, dispatch};
}
